import React, { useState } from 'react';
import { Copy, Check, AlertCircle, Key, Mail, UserCheck } from 'lucide-react';
import { DialogShell } from './ui/DialogShell';
import { Button } from './ui/Button';

interface CredencialesGeneradasModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  password: string;
  nombreCompleto: string;
}

export const CredencialesGeneradasModal: React.FC<CredencialesGeneradasModalProps> = ({
  isOpen,
  onClose,
  email,
  password,
  nombreCompleto,
}) => {
  const [copiedEmail, setCopiedEmail] = useState(false);
  const [copiedPassword, setCopiedPassword] = useState(false);
  const [copiedAll, setCopiedAll] = useState(false);

  const mensajeCompleto = `¡Hola ${nombreCompleto}!

Te damos la bienvenida a la Aplicación de Gestión Administrativa Gnóstica.

Tus credenciales de acceso son:

📧 Email: ${email}
🔑 Contraseña: ${password}

Por favor, ingresa a la aplicación con estos datos.

URL: ${window.location.origin}

¡Saludos!`;

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 2000);
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };

  const handleCopyPassword = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopiedPassword(true);
      setTimeout(() => setCopiedPassword(false), 2000);
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };

  const handleCopyAll = async () => {
    try {
      await navigator.clipboard.writeText(mensajeCompleto);
      setCopiedAll(true);
      setTimeout(() => setCopiedAll(false), 2000);
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };

  return (
    <DialogShell
      isOpen={isOpen}
      onClose={onClose}
      title="Credenciales Generadas"
    >
      <div className="space-y-4">
        <div className="flex items-start gap-3 p-4 bg-green-50 border border-green-200 rounded-lg">
          <UserCheck className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-green-900">
              Cuenta creada exitosamente
            </p>
            <p className="text-sm text-green-700 mt-1">
              Se ha creado la cuenta de <strong>{nombreCompleto}</strong> y se generaron las credenciales de acceso automáticamente.
            </p>
          </div>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg space-y-3">
          <div>
            <label className="block text-xs font-medium text-slate-500 uppercase mb-1">
              Email
            </label>
            <div className="flex items-center gap-2">
              <div className="flex-1 flex items-center gap-2 p-2 bg-white border border-slate-300 rounded-lg">
                <Mail className="w-4 h-4 text-slate-400" />
                <span className="text-sm text-slate-900 font-mono">{email}</span>
              </div>
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={handleCopyEmail}
                className="shrink-0"
              >
                {copiedEmail ? (
                  <Check className="w-4 h-4 text-green-600" />
                ) : (
                  <Copy className="w-4 h-4" />
                )}
              </Button>
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-500 uppercase mb-1">
              Contraseña
            </label>
            <div className="flex items-center gap-2">
              <div className="flex-1 flex items-center gap-2 p-2 bg-white border border-slate-300 rounded-lg">
                <Key className="w-4 h-4 text-slate-400" />
                <span className="text-sm text-slate-900 font-mono">{password}</span>
              </div>
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={handleCopyPassword}
                className="shrink-0"
              >
                {copiedPassword ? (
                  <Check className="w-4 h-4 text-green-600" />
                ) : (
                  <Copy className="w-4 h-4" />
                )}
              </Button>
            </div>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Mensaje para WhatsApp
          </label>
          <textarea
            value={mensajeCompleto}
            readOnly
            rows={12}
            className="w-full p-3 border border-slate-300 rounded-lg bg-slate-50 text-sm resize-none font-mono"
          />
        </div>

        <div className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
          <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-amber-800">
            <strong>Importante:</strong> Copia y envía estas credenciales al miembro por WhatsApp u otro medio seguro. Estas credenciales no se volverán a mostrar.
          </p>
        </div>

        <div className="flex gap-3">
          <Button
            type="button"
            variant="primary"
            onClick={handleCopyAll}
            className="flex-1"
          >
            {copiedAll ? (
              <>
                <Check className="w-4 h-4 mr-2" />
                Mensaje Copiado
              </>
            ) : (
              <>
                <Copy className="w-4 h-4 mr-2" />
                Copiar Mensaje Completo
              </>
            )}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </div>
      </div>
    </DialogShell>
  );
};
